export function artifactSessionHref(sessionId: string, artifactId: string): string {
  return `/workspace/sessions/${encodeURIComponent(sessionId)}?artifact=${encodeURIComponent(artifactId)}`;
}

/** Resolve an ID-only reference through the permission-checked artifact route. */
export function artifactWorkspaceHref(artifactId: string, sessionId?: string): string {
  return sessionId ? artifactSessionHref(sessionId, artifactId)
    : `/workspace/artifacts/${encodeURIComponent(artifactId)}`;
}
